module.exports = __webpack_public_path__ + "img/button_Home.7d26b7a7.svg";